import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
  Cell,
} from "recharts";
import React, { useState, useEffect } from "react";

const HorizontalBarChart = ({ stats }) => {
  const base =
    (stats?.contributors_detailed?.length
      ? stats.contributors_detailed.map((c) => ({
          name: c.login || c.name || "unknown",
          commits: c.contributions ?? 0,
          avatar: c.avatar_url || null,
        }))
      : Object.entries(stats?.commits?.authors || {}).map(([name, count]) => ({
          name,
          commits: count,
          avatar: null,
        }))) || [];

  const data = [...base]
    .sort((a, b) => (b.commits || 0) - (a.commits || 0))
    .slice(0, 5);

  if (!data.length) {
    return <p className="text-muted mb-0">No contributor commit data found.</p>;
  }

  // Rank → gradient pair
  const getGradient = (rank) => {
    if (rank >= 5) return ["#25B9D5", "#64C8DF"];
    if (rank === 4) return ["#F6A42B", "#F7B860"];
    if (rank === 3) return ["#F04E4D", "#F6817E"];
    if (rank === 2) return ["#9165F6", "#AB8AF9"];
    return ["#10b981", "#14eba3"]; // fallback grey
  };

  return (
    <div className="card p-3 shadow-sm h-100">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h5 className="mb-0">Top 5 contributors by commits</h5>
        {/* <small className="text-muted">
          {stats?.data_source
            ? stats.data_source.replaceAll("_", " ")
            : "from database"}
        </small> */}
      </div>

      <div style={{ width: "100%", height: 340 }}>
        <ResponsiveContainer>
          <BarChart
            layout="vertical"
            data={data}
            margin={{ top: 8, right: 28, left: 16, bottom: 8 }}
            barCategoryGap={12}
          >
            <CartesianGrid strokeDasharray="3 3" />
            {/* <XAxis type="number" allowDecimals={false} /> */}
            <XAxis
  type="number"
  allowDecimals={false}
  label={{
    value: "Number of commits",
    position: "insideBottom",
    offset: -5,
    style: { textAnchor: "middle", fill: "#374151", fontWeight: 400 }
  }}
/>
            <YAxis type="category" dataKey="name" width={0} tick={false} />

            <Tooltip
              formatter={(value) => [value, "Commits"]}
              labelFormatter={(label) => `Contributor: ${label}`}
            />

            <defs>
              {data.map((entry, i) => {
                const [from, to] = getGradient(data.length - i);
                return (
                  <linearGradient
                    id={`grad-${i}`}
                    key={i}
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                  >
                    {/* Solid for the first 30% */}
                    <stop offset="0%" stopColor={from} stopOpacity={1} />
                    <stop offset="30%" stopColor={to} stopOpacity={1} />
                    {/* Then start fading out */}
                    {/* <stop offset="70%" stopColor={to} stopOpacity={0.4} /> */}
                    <stop offset="100%" stopColor={to} stopOpacity={0.4} />
                  </linearGradient>
                );
              })}
            </defs>

            <Bar
  dataKey="commits"
  isAnimationActive={true}
  barSize={50}
  radius={[2, 2, 2, 2]}
>
  {data.map((entry, i) => (
    <Cell key={`cell-${i}`} fill={`url(#grad-${i})`} />
  ))}

  {/* Contributor names inside bars */}
  <LabelList
    dataKey="name"
    position="insideLeft"
    offset={10}  // move text slightly inside
    style={{ fill: "#fff", fontWeight: 400 }}
  />

  {/* Commits count at the end of the bar */}
  <LabelList
    dataKey="commits"
    position="right"
    style={{ fill: "#111", fontWeight: 500 }}
  />
</Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HorizontalBarChart;